<div class="card">
  <form
    [formGroup]="form()"
    class="profile-info-form"
    id="address"
    (ngSubmit)="submitHandler()"
    validateOnSubmit
  >
    <!--<suite-custom-code-block-5>-->
    <!--</suite-custom-code-block-5>-->

    <div class="mt-2 fade-in-top properties-container" *ngIf="!isLoading()">

      <div class="mb-3">
        <label class="form-label" for="name">
          {{ '::FullName' | abpLocalization }}<span>*</span>
        </label>

        <input id="name" formControlName="name" class="form-control" [maxlength]="50" />
      </div>

      <div class="mb-3">
        <label class="form-label" for="name">
          {{ '::Email' | abpLocalization }}<span>*</span>
        </label>
        <div class="input-group d-flex flex-nowrap">
          <div class="d-flex flex-grow email-action-buttons">
            <input id="email" formControlName="email" class="form-control" />
            <button
              *ngIf="!currentUser().emailVerified"
              (click)="sendEmailConfirmation()"
              class="btn {{ verfiyButtonClass }} ng-star-inserted d-flex align-items-center verify"
              type="button"
            >
              <i aria-hidden="true" class="me-1 fa fa-vcard"></i>
              {{ '::Verify' | abpLocalization }}
            </button>

            <button
              *ngIf="currentUser().emailVerified"
              [class.active]="false"
              class="btn {{ verfiyButtonClass }} border ng-star-inserted d-flex align-items-center"
              type="button"
            >
              <ng-template
                [ngIfElse]="no"
                [ngIfThen]="yes"
                [ngIf]="currentUser().email === form().get('email').value"
              ></ng-template>
              <ng-template #yes>
                <i aria-hidden="true" class="me-1 text-success fa fa-check-square"></i>
                <span class="text-success">
                  {{ '::Verified' | abpLocalization }}
                </span>
              </ng-template>
              <ng-template #no>
                <i aria-hidden="true" class="me-1 fa fa-times"></i>
                <span class="text-danger">
                  {{ '::NotVerified' | abpLocalization }}
                </span>
              </ng-template>
            </button>
          </div>
        </div>
      </div>

      <div class="mb-3 d-flex input-group phone-action-buttons">
        <app-phone-input
          [phoneNumberLabel]="'::PhoneNumber'"
          [errorMessage]="phoneErrorMessage"
          [initPhoneValue]="phoneNumber"
          [onPhoneChange]="phoneNumberHandler.bind(this)"
        ></app-phone-input>
        <button
          *ngIf="!currentUser().phoneNumberVerified"
          (click)="sendPhoneConfirmation()"
          class="btn btn-warning ng-star-inserted d-flex align-items-center verify"
          type="button"
        >
          <i aria-hidden="true" class="me-1 fa fa-vcard"></i>
          {{ '::Verify' | abpLocalization }}
        </button>
        <button
          *ngIf="currentUser().phoneNumberVerified"
          [class.active]="false"
          class="btn bg-white border ng-star-inserted d-flex align-items-center verify"
          type="button"
        >
          <ng-template
            [ngIfElse]="no"
            [ngIfThen]="yes"
            [ngIf]="isPhoneNumberChanged"
          ></ng-template>
          <ng-template #yes>
            <i aria-hidden="true" class="me-1 text-success fa fa-check-square"></i>
            <span class="text-success">
              {{ '::Verified' | abpLocalization }}
            </span>
          </ng-template>
          <ng-template #no>
            <i aria-hidden="true" class="me-1 fa fa-times"></i>
            <span class="text-danger">
              {{ '::NotVerified' | abpLocalization }}
            </span>
          </ng-template>
        </button>
      </div>
    </div>

    <div *ngIf="isLoading()">
      <div class="shimmer-item" *ngFor="let _ of [].constructor(4)">
        <div class="shimmer"></div>
      </div>
    </div>
    <button class="btn btn-primary" formName="address">
      {{ 'AbpUi::Save' | abpLocalization }}
    </button>
  </form>
</div>

@defer(when isConfirmationVisible()) {
<app-phone-confirmation-modal
  [isVisible]="isConfirmationVisible()"
  [currentUserId]="currentUser()?.id"
  [onResend]="sendPhoneConfirmation.bind(this)"
  [verificationCodeValidity]="verificationCodeValidity()"
  [close]="closeConfiramtionPopup.bind(this)"
/>
}
